import * as React from 'react';
import {
  Form,
  FormBody,
  Modal,
  ModalContent,
  ModalHeader,
  ModalSection,
  Title,
} from '@zen-common/components-base';
import { assetUtils } from '@zen/common-utils';
import { NamingAssetStore, FpUtils } from '@zen/common-app-parts';
import { IssueStore } from '../../stores/FixedPayoutStore';
import CommandFG from '../../components/form/result/CommandFG';
import MessageBodyFG from '../../components/form/result/MessageBodyFG';
import AssetFG from '../../components/form/result/AssetFG';
import AmountFG from '../../components/form/result/AmountFG';
import ContractFG from '../../components/form/result/ContractFG';
import IncludeAuthCheckBoxFG from '../../components/form/result/IncludeAuthCheckBoxFG';
import QRCodeFG from '../../components/form/result/QRCodeFG';
import CopyResultFF from '../../components/form/result/CopyResultFF';
import useContract from '../../hooks/useContract';

export default function IssueResult() {
  const [qrExpanded, setQrExpanded] = React.useState(false);
  const { address } = useContract();
  const {
    state: { result, collateralAsset, collateralAmount },
  } = IssueStore.useStore();

  const { state: naming } = NamingAssetStore.useStore();

  const fieldsToCopy = result.messageBody
    ? {
        address,
        spends: [
          {
            asset: assetUtils.getAssetRepresentationId(collateralAsset.value),
            amount: collateralAmount.value.safeValue,
          },
        ],
        command: 'Issue',
        messageBody: result.messageBody,
        includeAuthentication: true,
      }
    : null;

  return (
    <Modal>
      <ModalContent large>
        <ModalHeader>
          {!qrExpanded && <Title>Paste the following in the wallet to execute</Title>}
        </ModalHeader>
        <ModalSection>
          <Form>
            <FormBody>
              {!qrExpanded && (
                <>
                  <ContractFG value={address} />
                  <AssetFG
                    label={FpUtils.getTitle({
                      asset: collateralAsset.value,
                      title: 'Collateral',
                      naming,
                    })}
                    value={collateralAsset.value}
                    readOnly
                  />
                  <AmountFG value={collateralAmount.value.display} />
                  <CommandFG value="Issue" />
                  <MessageBodyFG value={result.messageBody} />
                  <IncludeAuthCheckBoxFG />
                </>
              )}
              <QRCodeFG
                value={fieldsToCopy}
                expanded={qrExpanded}
                onQrClick={() => setQrExpanded((e) => !e)}
              />
            </FormBody>
            {!qrExpanded && <CopyResultFF fields={fieldsToCopy} />}
          </Form>
        </ModalSection>
      </ModalContent>
    </Modal>
  );
}
